import {Route, Routes} from 'react-router-dom'
import { Export } from './Export'

export const ExportRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Export />} />
    </Routes>
  )
}
